import { http } from '../plugins/http'
import TicketType from '@/types/TicketType'

export default class TicketTypeService {
  async destroy(configurationId: string, model: TicketType) {
    return await http.delete<TicketType>(`/api/v1/office/event-configurations/${configurationId}/ticket-types/${model.id}`)
  }

  async updateSortingOrder(configurationId: string, typeIds: string[]) {
    return await http.put(`/api/v1/office/event-configurations/${configurationId}/ticket-types/sorting`, { type_ids: typeIds })
  }
}
